import * as Yup from "yup" ;
export const LOGIN_SCHEMA = Yup.object().shape({
    username : Yup.string().required("Username is required") ,
    password : Yup.string().required("Password is required")
});
export const INITIAL_VALUES = {
    username : "" ,
    password : ""
}